import {Component, EventEmitter, Output} from '@angular/core';
import {ConfigService} from '../../service/config.service';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.css']
})
export class CaptchaComponent {

  @Output()
  resolved = new EventEmitter<string>();
  @Output()
  error = new EventEmitter<any>();
  recaptchaSiteKey: string;

  constructor(private configService: ConfigService) {
    this.recaptchaSiteKey = this.configService.getRecaptchaSiteKey();
  }

  onResolve(captchaResponse: string): void {
    this.resolved.emit(captchaResponse);
  }
  onError(errorDetails: any): void {
    this.error.emit(errorDetails);
  }
}
